// src/context/AuthContext.js
import React, { createContext, useState, useContext, useEffect } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem("authToken") || null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Initialize user state from token
  useEffect(() => {
    if (token) {
      setCurrentUser({ email: "admin@readablenglish.com" });
    } else {
      setCurrentUser(null);
    }
    setLoading(false);
  }, [token]);

  const loginWithEmailPassword = async (email, password) => {
    try {
      setLoading(true);
      if (email === "admin@readablenglish.com" && password === "Password123!") {
        const defaultToken = "zWHYqGRsya-kwyVGRck3";
        setToken(defaultToken);
        localStorage.setItem("authToken", defaultToken);
        setCurrentUser({ email });
        return { token: defaultToken, user: { email } };
      } else {
        throw new Error("Invalid email or password");
      }
    } catch (error) {
      console.error("Login error:", error);
      toast.error("Login failed: " + error.message);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    setCurrentUser(null);
    setToken(null);
    localStorage.removeItem("authToken");
    navigate("/login");
    toast.info("Logged out successfully");
  };

  const isAuthenticated = () => {
    return !!token;
  };

  const getAuthHeader = () => {
    return token ? { Authorization: `ApiKey ${token}` } : {};
  };

  const value = {
    currentUser,
    loading,
    logout,
    isAuthenticated,
    getAuthHeader,
    loginWithEmailPassword,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
